import { Observable } from "rxjs";
import { inject, injectable } from "tsyringe";
import { SurveysService } from "src/containers/surveys/services/surveys-service/surveys-service";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class SurveyTransaction {
    constructor(@inject("SurveysService") private service: SurveysService) {}

    @autoBind
    create(): Observable<number> {
        return this.service.recordTransaction();
    }
}
